import * as React from "react";
const SvgUserProfile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M9.855 0a6.656 6.656 0 0 0-6.65 6.65c0 3.599 2.814 6.51 6.482 6.637a1.1 1.1 0 0 1 .308 0h.098a6.634 6.634 0 0 0 6.413-6.637A6.656 6.656 0 0 0 9.856 0M16.969 17.01c-3.906-2.605-10.277-2.605-14.21 0C.98 18.2 0 19.81 0 21.531s.98 3.318 2.744 4.494C4.704 27.342 7.28 28 9.857 28c2.576 0 5.152-.658 7.112-1.974 1.764-1.19 2.744-2.786 2.744-4.522-.014-1.722-.98-3.318-2.744-4.495"
    />
  </svg>
);
export default SvgUserProfile;
